export default "__VITE_ASSET__PMv_KW41__"